export default {
  home: '/',
  create: '/create',
  userProfile: '/user/profile',
  features: '/features',
  benefits: '/benefits',
  tipsAndSamplePages: '/tips-sample-pages',
  competitors: '/competitors',
  commonQuestions: '/faq',
  howItWork: '/how-inkind-works',
  about: '/about-us',
  contact: '/contact',
  giveBySituation: '/give/by/situation',
  give: '/give',
  blog: '/articles',
  giftGuides: '/articles/general-results/article-type/buying-guide',
  byGiftType: '/give/by/category',
  termsService: '/terms-service',
  privacyPolicy: '/privacy-policy',
  support: 'https://help.giveinkind.com/en',
};
